// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__g8JP5","overlay":"styles_overlay__Vt6VS"};